import { Button, Card, IconButton, TextField } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import {
  CheckBox,
  CheckBoxOutlineBlank,
  PersonAddRounded,
  SearchOutlined,
  Visibility,
} from "@material-ui/icons";
import {
  Dialog,
  DialogActions,
  DialogTitle,
  Pagination,
  Tooltip,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { startLoading, stopLoading } from "../../actions/loadingAction";
import { errorSnackbar, successSnackbar } from "../../actions/snackbarActions";
import { Endpoint, Status } from "../../apis/apiConstants";
import AjaxHelper from "../../apis/apiRequest";
import { USER_TYPE } from "../../common/constants";
import MDialog from "../../components/MDialog/mDialog";
import SessionDetails from "../../helpers/sessionDetails";
import { getCopy, scrollToTop } from "../../helpers/utils.helper";
import "./members.scss";

export default function Members(props) {
  const dispatch = useDispatch();
  const [members, setMembers] = useState([]);
  const [memberPages, setMemberPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = React.useState(false);
  const [selectedRoles, setSelectedRoles] = React.useState([]);
  const [roleSelectionOpen, setRoleSelectionOpen] = React.useState(false);
  const navigate = useNavigate();

  React.useEffect(() => {
    getMemberCount("");
    getMembers(1, "");
  }, []);

  const getMembers = (page, search) => {
    dispatch(startLoading);
    AjaxHelper.getApi(navigate, Endpoint.GET_ALL_MEMBERS, {}, { page, search })
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_SUCCESS) {
          setMembers(response.data.data);
          setSelectedUser(response.data.data[0]);
          scrollToTop();
        } else {
          dispatch(errorSnackbar(response.data.message));
        }
      })
      .catch((error) => {
        dispatch(stopLoading);
        dispatch(errorSnackbar("Error fetching members."));
      });
  };
  const getMemberCount = (search) => {
    AjaxHelper.getApi(navigate, Endpoint.GET_MEMBER_PAGES, {}, { search })
      .then((response) => {
        if (response.data.status === Status.API_SUCCESS) {
          setMemberPages(response.data.data.pages);
        }
      })
      .catch((error) => {
        dispatch(errorSnackbar("Error in fetching member pages."));
      });
  };

  const assignRoles = (uid, roles) => {
    dispatch(startLoading);
    AjaxHelper.postApi(navigate, Endpoint.ASSIGN_ROLES, {
      _id: uid,
      roles,
    })
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_SUCCESS) {
          const updatedMembers = getCopy(members);
          const fupdateMember = updatedMembers.filter((m) => m._id === uid)[0];
          fupdateMember.userType = roles;
          setMembers(updatedMembers);
          dispatch(successSnackbar("Roles updated successfully!"));
        } else {
          dispatch(errorSnackbar(response.data.message));
        }
      })
      .catch((error) => {
        dispatch(stopLoading);
      });
  };

  const onAssignRolesClick = (member) => {
    console.log(member);
    setSelectedUser(member);
    setRoleSelectionOpen(true);
    if (member.userType.includes(USER_TYPE.MASTER_ADMIN)) {
      setSelectedRoles(USER_TYPE.getUserTypes());
    } else if (member.userType.includes(USER_TYPE.JAMAT_ADMIN)) {
      setSelectedRoles([
        USER_TYPE.JAMAT_ADMIN,
        ...USER_TYPE.getUserTypesLower(USER_TYPE.JAMAT_ADMIN),
      ]);
    } else {
      setSelectedRoles([...member.userType]);
    }
  };

  const getMemberView = () => {
    return members.map((m) => (
      <TableRow>
        <TableCell className={"userFont"}>{m.userCode}</TableCell>
        <TableCell className={"userFont"}>
          {m.title + " " + m.firstName + " " + m.lastName}
        </TableCell>
        <TableCell className={"userFont"}>{m.jamatName}</TableCell>
        <TableCell className={"userFont"}>
          {m.city + "," + m.state + "," + m.country}
        </TableCell>
        <TableCell className={"userFont"}>
          {m.userType
            .map((ut) => ut.capitalize())
            .join(" | ")
            .replace("-", " ")}
        </TableCell>
        <TableCell align="center">
          <Tooltip title={"View"}>
            <IconButton
              onClick={() => {
                setSelectedUser(m);
                handleClickOpen();
              }}
            >
              <Visibility color={"primary"} />
            </IconButton>
          </Tooltip>
          {SessionDetails.getCurrentUser().userType.includes(
            USER_TYPE.MASTER_ADMIN
          ) ? (
            <Tooltip title={"Change roles"}>
              <IconButton onClick={() => onAssignRolesClick(m)}>
                <PersonAddRounded color={"action"} />
              </IconButton>
            </Tooltip>
          ) : SessionDetails.getCurrentUser().userType.includes(
              USER_TYPE.JAMAT_ADMIN
            ) && m.userType.includes(USER_TYPE.MASTER_ADMIN) ? null : (
            <Tooltip title={"Change roles"}>
              <IconButton onClick={() => onAssignRolesClick(m)}>
                <PersonAddRounded color={"action"} />
              </IconButton>
            </Tooltip>
          )}
        </TableCell>
      </TableRow>
    ));
  };

  const onPageChange = (page) => {
    setCurrentPage(page);
    getMembers(page);
  };

  const getMembersData = () => {
    getMembers(searchText.length > 0 ? 1 : currentPage, searchText);
    getMemberCount(searchText);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getUserFields = () => {
    if (selectedUser) {
      return (
        <div className={"d-flex flex-column gap-3 p-3"}>
          <div className={"d-flex flex-row gap-1"}>
            <div className={"col-md-6 col-sm-12"}>
              <div className={"font-bold font-14"}>Father's name</div>
              <div>{selectedUser.fathersName}</div>
            </div>
            <div className={"col-md-6 col-sm-12"}>
              <div className={"font-bold font-14"}>Mother's name</div>
              <div>{selectedUser.mothersName}</div>
            </div>
          </div>

          <div className={"d-flex flex-row gap-1"}>
            <div className={"col-md-6 col-sm-12"}>
              <div className={"font-bold font-14"}>Marital status</div>
              <div>{selectedUser.maritalStatus}</div>
            </div>
            <div className={"col-md-6 col-sm-12"}>
              <div className={"font-bold font-14"}>Date of birth</div>
              <div>{selectedUser.dateOfBirth}</div>
            </div>
          </div>

          <div className={"d-flex flex-row gap-1"}>
            <div className={"col-md-6 col-sm-12"}>
              <div className={"font-bold font-14"}>Spouse</div>
              <div>{selectedUser.spouseName}</div>
            </div>
            <div className={"col-md-6 col-sm-12"}>
              <div className={"font-bold font-14"}>Gender</div>
              <div>{selectedUser.gender}</div>
            </div>
          </div>

          <div className={"d-flex flex-row gap-1"}>
            <div className={"col-md-6 col-sm-12"}>
              <div className={"font-bold font-14"}>Mobile</div>
              <div>
                {"+" +
                  selectedUser.countryCallingCode +
                  "-" +
                  selectedUser.mobile}
              </div>
            </div>
            <div className={"col-md-6 col-sm-12"}>
              <div className={"font-bold font-14"}>Email</div>
              <div>{selectedUser.email}</div>
            </div>
          </div>

          <div className={"d-flex flex-row gap-1"}>
            <div className={"col-md-6 col-sm-12"}>
              <div className={"font-bold font-14"}>Qualification</div>
              {selectedUser.qualification.map((qualification, index) => (
                <div>{index + 1 + ") " + qualification}</div>
              ))}
            </div>
            <div className={"col-md-6 col-sm-12"}>
              <div className={"font-bold font-14"}>Profession</div>
              {selectedUser.profession.map((profession, index) => (
                <div>{index + 1 + ") " + profession}</div>
              ))}
            </div>
          </div>

          <div className={"d-flex flex-row gap-1"}>
            <div className={"col-md-6 col-sm-12"}>
              <div className={"font-bold font-14"}>Blood group</div>
              <div>{selectedUser.bloodGroup}</div>
            </div>
            <div className={"col-md-6 col-sm-12"}>
              {/*<div className={"font-bold font-14"}>Email</div>*/}
              {/*<div>{selectedUser.email}</div>*/}
            </div>
          </div>

          <div className={"d-flex flex-row gap-1"}>
            <div className={"col-md-12 col-sm-12"}>
              <div className={"font-bold font-14"}>Address</div>
              {selectedUser.address[0].landmark ? (
                <div>
                  {selectedUser.address[0].society +
                    ", " +
                    selectedUser.address[0].street +
                    ", " +
                    selectedUser.address[0].landmark +
                    ", " +
                    selectedUser.city +
                    ", " +
                    selectedUser.state +
                    ", " +
                    selectedUser.country +
                    ", PIN:" +
                    selectedUser.zip}
                </div>
              ) : (
                <div>
                  {selectedUser.address[0].society +
                    ", " +
                    selectedUser.address[0].street +
                    ", " +
                    selectedUser.city +
                    ", " +
                    selectedUser.state +
                    ", " +
                    selectedUser.country +
                    " PIN:" +
                    selectedUser.zip}
                </div>
              )}
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  };

  const selectRole = (role) => {
    let updatedRoles = getCopy(selectedRoles);
    if (updatedRoles.includes(role)) {
      updatedRoles.splice(updatedRoles.indexOf(role), 1);
    } else {
      let roles = [role];
      if (role === USER_TYPE.MASTER_ADMIN || role === USER_TYPE.JAMAT_ADMIN) {
        const r = USER_TYPE.getUserTypesLower(role);
        roles = [...roles, ...r];
      }
      updatedRoles = [...new Set([...updatedRoles, ...roles])];
    }
    console.log(updatedRoles);
    setSelectedRoles(updatedRoles);
  };

  const getRoleDisabled = (role) => {
    if (role === USER_TYPE.MASTER_ADMIN) {
      return false;
    } else if (role === USER_TYPE.JAMAT_ADMIN) {
      return selectedRoles.includes(USER_TYPE.MASTER_ADMIN);
    } else {
      const isHigherAvailable = selectedRoles.filter((r) =>
        [USER_TYPE.MASTER_ADMIN, USER_TYPE.JAMAT_ADMIN].includes(r)
      );
      return isHigherAvailable.length > 0;
    }
  };

  const onSubmitRoles = (roles) => {
    let userTypes = [...roles];
    if (roles.includes(USER_TYPE.MASTER_ADMIN)) {
      userTypes = [USER_TYPE.MASTER_ADMIN];
    } else if (roles.includes(USER_TYPE.JAMAT_ADMIN)) {
      userTypes = [USER_TYPE.JAMAT_ADMIN];
    }

    assignRoles(selectedUser._id, userTypes);
  };
  const getUserTypes = () => {
    if (
      SessionDetails.getCurrentUser().userType.includes(USER_TYPE.MASTER_ADMIN)
    ) {
      return USER_TYPE.getUserTypes();
    } else if (
      SessionDetails.getCurrentUser().userType.includes(USER_TYPE.JAMAT_ADMIN)
    ) {
      return USER_TYPE.getJamatAdminUserTypes();
    } else {
      return [];
    }
  };

  return (
    <div className={"members-component d-flex flex-column p-md-3"}>
      <div className="mb-3 col-6 col-md-3 p-md-0 p-3">
        <div className="d-flex flex-row justify-content-center align-content-center">
          <TextField
            fullWidth
            value={searchText}
            onKeyDown={(event) => {
              if (event.keyCode === 13) {
                getMembersData();
              }
            }}
            onChange={(event) => {
              setSearchText(event.target.value);
            }}
            placeholder="Search"
            InputProps={{
              endAdornment: (
                <IconButton onClick={() => getMembersData()}>
                  <SearchOutlined />
                </IconButton>
              ),
            }}
          />
          <Button
            variant={"text"}
            className="button"
            onClick={() => {
              setCurrentPage(1);
              setSearchText("");
              getMembers(1, "");
              getMemberCount("");
            }}
          >
            Reset
          </Button>
        </div>
      </div>
      <Card className="innerCard mt-3 " variant="outlined">
        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow className={"background-color-head"}>
                <TableCell>
                  <span className={"font-bold font-18"}>Memon ID</span>
                </TableCell>
                <TableCell>
                  <span className={"font-bold font-18"}>Name</span>
                </TableCell>
                <TableCell>
                  <span className={"font-bold font-18"}>Jamaat</span>
                </TableCell>
                <TableCell>
                  <span className={"font-bold font-18"}>Location</span>
                </TableCell>
                <TableCell>
                  <span className={"font-bold font-18"}>Roles</span>
                </TableCell>
                <TableCell>
                  <span className={"font-bold font-18"}>Action</span>
                </TableCell>
              </TableRow>
            </TableHead>
            {getMemberView()}
          </Table>
        </TableContainer>

        {memberPages > 0 ? (
          <Pagination
            className={"mpagination"}
            count={memberPages}
            value={currentPage}
            variant="outlined"
            shape="rounded"
            onChange={(event, page) => onPageChange(page)}
          />
        ) : null}
      </Card>

      <Dialog fullScreen={fullScreen} open={open} onClose={handleClose}>
        <DialogTitle className={"background-color-head"}>
          <span className={"font-bold font-18"}>
            {selectedUser
              ? selectedUser.title +
                " " +
                selectedUser.firstName +
                " " +
                selectedUser.lastName +
                " (" +
                selectedUser.userCode +
                ")"
              : ""}
          </span>
        </DialogTitle>
        <Divider />

        <div className={"user-form"}>{getUserFields()}</div>
        <DialogActions>
          <Button onClick={handleClose}>Ok</Button>
        </DialogActions>
      </Dialog>

      <MDialog
        title={"Manage roles"}
        open={roleSelectionOpen}
        onClose={() => {
          setSelectedRoles([]);
          setRoleSelectionOpen(false);
        }}
        onNegative={() => {
          setSelectedRoles([]);
          setRoleSelectionOpen(false);
        }}
        onPositive={() => {
          onSubmitRoles(getCopy(selectedRoles));
          setRoleSelectionOpen(false);
        }}
        negativeLabel="Cancel"
        positiveLabel="Submit"
      >
        {getUserTypes().map((userType) => {
          return (
            <div
              style={{
                borderBottom: "1px solid #5B7586",
                padding: 8,
                display: "flex",
                gap: 8,
                alignItems: "center",
              }}
            >
              <IconButton
                disabled={getRoleDisabled(userType)}
                onClick={() => {
                  console.log("clicked");
                  selectRole(userType);
                }}
              >
                {selectedRoles.includes(userType) ? (
                  <CheckBox color={"primary"} />
                ) : (
                  <CheckBoxOutlineBlank color={"primary"} />
                )}
              </IconButton>
              <div className={"appFontMedium"} style={{ color: "#5B7586" }}>
                {userType.capitalize().replace("-", " ")}
              </div>
            </div>
          );
        })}
      </MDialog>
    </div>
  );
}
